import React from 'react'
import { CSVLink } from 'react-csv'

import { Icon } from '@st-operations/uikit/src/v2'
import Table from '../table'

import './styles.scss'

// descending; scores 1th; users 2th
const sortExport = (data) => {
  const newData = [...data]
  newData.sort((a, b) => {
    if (a.score > b.score) return -1
    else if (a.score < b.score) return 1
    else if (a.users > b.users) return -1
    else if (a.users < b.users) return 1
    else return 0
  })
  return newData
}

export const SCORE_TO_LABEL = {
  EXACT_MATCH: 'Exact Match',
  HIGH_SIMILARITY: 'High Similarity',
  MEDIUM_SIMILARITY: 'Medium Similarity',
  LOW_SIMILARITY: 'Low Similarity',
}

export const SCORE_RANGE = {
  [SCORE_TO_LABEL.EXACT_MATCH]: { max: 1, min: 1 },
  [SCORE_TO_LABEL.HIGH_SIMILARITY]: { max: 0.9999, min: 0.6 },
  [SCORE_TO_LABEL.MEDIUM_SIMILARITY]: { max: 0.6, min: 0.5 },
  [SCORE_TO_LABEL.LOW_SIMILARITY]: { max: 0.5, min: 0 },
}

const transformScore = (score) => {
  if (score === 1) return SCORE_TO_LABEL.EXACT_MATCH
  if (score >= 0.6) return SCORE_TO_LABEL.HIGH_SIMILARITY
  if (score >= 0.5) return SCORE_TO_LABEL.MEDIUM_SIMILARITY
  else return SCORE_TO_LABEL.LOW_SIMILARITY
}

const CandidateUrlsList = ({ data, updateSelected, selectedUsers }) => {
  const selectedLength = data.candidateUrls.filter((url) => url.selected)?.length

  const exportData = data.candidateUrls.map((item) => {
    const copy = { ...item }
    delete copy.fakeNewsLabel
    delete copy.fakeNewsLabelConfidence
    return copy
  })

  return (
    <div className="tab-candidate-urls-list">
      <div className="tab-candidate-urls-list__header">
        <h3 className="tab-candidate-urls-list__header-title">Candidate URLs</h3>
        <p className="tab-candidate-urls-list__header-subtitle">
          We found these URLs that matches your request
        </p>
      </div>
      <div className="tab-candidate-urls-list__content">
        <Table
          columns={[
            {
              key: 'canonicalUrl',
              name: 'Candidate URLs',
              sortable: true,
              class: 'fake-ellipsis',
              format: (val) => (
                <a href={val} target="_blank" rel="nofollow">
                  {val}
                </a>
              ),
            },
            {
              key: 'score',
              name: 'Score',
              sortable: true,
              format: transformScore,
            },
            {
              key: 'users',
              name: 'Users',
              sortable: true,
            },
            {
              key: 'usersPct',
              name: 'Users %',
              format: (val) => (val * 100).toFixed(2) + ' %',
            },
            {
              key: 'events',
              name: 'Events',
              sortable: true,
            },
            {
              key: 'eventsPct',
              name: 'Events %',
              format: (val) => (val * 100).toFixed(2) + ' %',
            },
            {
              key: 'internalUsers',
              name: 'Internal Users',
              sortable: true,
            },
            {
              key: 'internalUsersPct',
              name: 'Internal Users %',
              format: (val) => (val ? (val * 100).toFixed(2) + ' %' : null),
            },
            {
              key: 'mediaBias',
              name: 'Media Bias',
              extra: true,
            },
            // {
            //   key: 'fakeNewsLabel',
            //   name: 'Fake News',
            //   extra: true,
            //   tooltip: 'fakeNewsLabelConfidence',
            //   tooltipFormat: (value) => `Confidence: ${(value * 100).toFixed()}%`,
            // },
          ]}
          data={data}
          updateSelected={updateSelected}
        />
      </div>
      <div className="tab-candidate-urls-list__footer">
        <div>
          <p>URLs Selected: {selectedLength.toLocaleString()}</p>
          <If condition={selectedUsers < 25}>
            <p className="tab-candidate-urls-list__footer-warning">
              <Icon icon="info" type="outline" /> Please select URLs until reach 25 users (current:{' '}
              {selectedUsers})
            </p>
          </If>
        </div>
        <div>
          <CSVLink
            data={sortExport(exportData)}
            filename={`${data.name} - ${new Date().toISOString().split('T')[0]}.csv`}
            className="ds st-button default primary"
          >
            {'Export URLs'}
          </CSVLink>
        </div>
      </div>
    </div>
  )
}

export default CandidateUrlsList
